export default __webpack_public_path__ + "4e52bcbfe652f3a3a71d00b40c2b57d1.png";